export default __webpack_public_path__ + "car_icon.aa817653.svg";